import React, {useEffect} from 'react';
import {Stack, ThemeProvider, useTheme} from '@mui/material';

import {
    setDocument, setHtml, setPlain,
    useInspectorDrawerOpen,
    useSamplesDrawerOpen
} from "../../modules/email-editor/documents/editor/EditorContext";
import InspectorDrawer, {INSPECTOR_DRAWER_WIDTH} from "../../modules/email-editor/InspectorDrawer";
import TemplatePanel from "../../modules/email-editor/TemplatePanel";
import EmailEditorTheme from "../../config/EmailEditorTheme";
import {useAppContext} from "../../AppContext";
import getConfiguration from "../../modules/email-editor/getConfiguration";
import {useManagerContext} from "./ManagerContext";

function useDrawerTransition(cssProperty, open) {
    const {transitions} = useTheme();
    return transitions.create(cssProperty, {
        easing  : !open ? transitions.easing.sharp : transitions.easing.easeOut,
        duration: !open ? transitions.duration.leavingScreen : transitions.duration.enteringScreen,
    });
}


export const Editor = () => {
    const inspectorDrawerOpen = useInspectorDrawerOpen();
    const samplesDrawerOpen = useSamplesDrawerOpen();
    const {showTopbar} = useAppContext();
    const {email} = useManagerContext();

    const marginLeftTransition = useDrawerTransition('margin-left', samplesDrawerOpen);
    const marginRightTransition = useDrawerTransition('margin-right', inspectorDrawerOpen);


    useEffect(() => {
        showTopbar(false);
        return () => showTopbar(true);
    }, []);


    useEffect(() => {
        if (email?.content?.document) {
            try {
                const doc = JSON.parse(email?.content?.document)
                setDocument(doc);
                setHtml(email?.content?.html)
                setPlain(email?.content?.plain)

            } catch (e) {
                setDocument(getConfiguration(window.location.hash))
            }
        } else {
            setDocument(getConfiguration(window.location.hash))
        }

    }, [email]);


    return (
        <>
            <ThemeProvider theme={EmailEditorTheme}>
                <InspectorDrawer/>

                <Stack
                    sx={{
                        marginLeft : 0,
                        marginRight: inspectorDrawerOpen ? `${INSPECTOR_DRAWER_WIDTH}px` : 0,
                        transition : [marginLeftTransition, marginRightTransition].join(', '),
                    }}
                >
                    <TemplatePanel/>
                </Stack>
            </ThemeProvider>
        </>
    );
}
